import Rest from '@services/Rest';

/**
 * @typedef {IdentityService}
 */
export default class IdentityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/identity-validation'
}
